<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <pb-body-base class="cart-overview" :busy="loadingCart">
        <template v-slot:default="props">
            <pb-body>
                <template slot="title">
                    <b-row class="mt-7 mb-4">
                        <b-col class="text-center">
                            <h3>{{cartCategoryTitle}}</h3>
                            <hr/>
                        </b-col>
                    </b-row>
                </template>
                <template slot="body" v-if="cart">
                    <b-container>
                        <b-row>
                            <b-col lg="8">
                                <h6 class="d-none d-lg-block">SHOPPING BAG</h6>
                                <router-link :to="{ name: 'checkout', params: {cartId: cart.id}}" tag="button"
                                             class="btn btn-block my-2 btn-primary d-lg-none">GO TO CHECKOUT
                                </router-link>
                                <transition-group name="list" tag="div">
                                <div :key="item" v-for="(item) in cart.shoppingCartItemList">

                                        <cart-overview-item  v-if="isDesktop" :cart="cart" :item="itemArray[item]"/>
                                        <cart-overview-item-mobile v-else :cart="cart" :item="itemArray[item]"/>

                                </div>
                                </transition-group>
                            </b-col>
                            <b-col lg="4" class="d-none d-lg-block">
                                <h6>ORDER SUMMARY</h6>
                                <div class="bg-gray p-3">
                                    <b-row>
                                        <b-col>
                                            <b>Price</b>
                                        </b-col>
                                        <b-col class="text-right">
                                            <b>{{total | currency($currencyFormatting[currency])}}</b>
                                        </b-col>
                                    </b-row>
                                </div>
                                <router-link :to="{ name: 'checkout', params: {cartId: cart.id}}" tag="button"
                                             class="btn btn-block mt-3 btn-primary btn-lg">GO TO CHECKOUT
                                </router-link>
                            </b-col>
                        </b-row>
                    </b-container>
                </template>
                <template slot="body" v-else>
                    <b-container>
                        <b-row>
                            <b-col>
                                <b-alert variant="warning" show>Selected Shopping Cart is empty.</b-alert>
                            </b-col>
                        </b-row>
                    </b-container>
                </template>
            </pb-body>
        </template>
    </pb-body-base>
</template>

<script>


    import {mapActions, mapGetters, mapState} from "vuex";
    import CartOverviewItem from "./CartOverviewItem";
    import CartOverviewItemMobile from "./CartOverviewItemMobile";
    import CartBase from "./CartBase";

    export default {
        name: 'cart-overview',
        props: {},
        extends: CartBase,
        components: {
            'cart-overview-item': CartOverviewItem,
            'cart-overview-item-mobile': CartOverviewItemMobile
        },
        data() {
            return {
                cartId: null,
                busy: false
            };
        },
        beforeRouteUpdate(to, from, next) {
            this.initCart(to.params.cartId);
            next();
        },
        created() {
            this.initCart(this.$route.params.cartId);
        },
        methods: {
            ...mapActions("cart", ["fetchCart"]),
            initCart: function (cartId) {
                this.cartId = Number(cartId);
            },
        },
        computed: {
            ...mapState("cart", ['loadingCart']),
            ...mapGetters('cart', ['cartArray', 'itemArray', 'cartById']),
            ...mapGetters('media', ['isDesktop']),
            cart: function () {
                return this.cartById(this.cartId);
            },
            cartCategoryTitle: function () {
                return (this.cart && this.cart.category && this.cart.customerCategoryId > 0) ? `Shopping bag „${(this.cart.category.webName || this.cart.category.name)}“` : "Shopping Bag"
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .cart-overview {

    }
</style>
